var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nurse-table',{attrs:{"canDelete":true,"viewRoute":"ClinicNurseDetails","canCreate":true,"viewDetailRoute":"ClinicNurseDetailView","createRoute":"ClinicNurseCreate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }